import "core-js/modules/web.dom-collections.iterator.js";
import { SharingRemixPage } from "~/utils/sharing-remix-page";
import { UserBody } from "./body";
import { UserHead } from "./head";
import { buildSharingLoader } from "~/utils/sharing-loader";
import { cssLinks } from "@ttark/css-links";
var links = () => [...cssLinks("routes/$user_link_name")];
var loader = buildSharingLoader("user");
var UserPage = class extends SharingRemixPage {
  constructor() {
    super(...arguments);
    this.Head = UserHead;
    this.Body = UserBody;
  }
};
var clientLoader = async _ref => {
  let {
    serverLoader
  } = _ref;
  const serverData = await serverLoader();
  return serverData;
};
export { clientLoader, UserPage as default, links };